module.exports = __webpack_public_path__ + "img/footer-logo-TrustEd.fc581314.png";